exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".manageReportPage__description___2wweH {\n  display: block;\n  width: 200px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden; }\n\n.manageReportPage__link___15JIX {\n  color: blue; }\n\n.manageReportPage__descriptionExpanded___1bN7B {\n  white-space: pre-line; }\n\n.manageReportPage__emailSentStyle___2mQm6 > label,\n.manageReportPage__solved___kLny- > label {\n  display: block; }\n", ""]);

// exports
exports.locals = {
	"description": "manageReportPage__description___2wweH",
	"link": "manageReportPage__link___15JIX",
	"descriptionExpanded": "manageReportPage__descriptionExpanded___1bN7B",
	"emailSentStyle": "manageReportPage__emailSentStyle___2mQm6",
	"solved": "manageReportPage__solved___kLny-"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/routes/Admin/ManageReportPage/manageReportPage.scss
// module id = 4027
// module chunks = 6